import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import { baseURL } from 'Types/APITypes';
import { useQuery } from 'react-query';

async function getLastUpdate(btNumber: string) {
  const apiType: MaestroAPI = { method: 'GET', endpoint: `locations/last-update?accountNumber=${btNumber}`, baseURL };
  const res = await maestroApiCall(apiType).then((r) => r.data);
  return res;
}

export function useLastUpdateLocations(btNumber: string) {
  return useQuery(['locations-last-update'], () => getLastUpdate(btNumber));
}
